import { useCallback } from 'react';
import { useMutation } from 'react-query';

import { TRIAL_FEATURES } from '@discover-frontend/components';

import { isTrialUser } from 'src/utils/AuthHelperMethods';

import { useTrialPaywall } from '../../../providers/TrialPaywallProvider';
import {
  fetchTrialStatus,
  isTrialActive,
  isTrialQueryCreationBlocked,
} from '../../request';

export const useGuardAnalyze = () => {
  const { isLockedOut, openUnlockModal, markSessionQuotaExhausted } =
    useTrialPaywall();
  const { mutateAsync, isLoading } = useMutation(() => fetchTrialStatus());

  const guardAnalyze = useCallback(
    (onAllowed: () => void) => {
      if (isLockedOut || isLoading) return;

      mutateAsync()
        .then((trialStatus) => {
          if (isTrialUser() && !isTrialActive(trialStatus)) {
            markSessionQuotaExhausted();
            return;
          }

          if (isTrialUser() && isTrialQueryCreationBlocked(trialStatus)) {
            openUnlockModal(TRIAL_FEATURES.TRIAL_QUOTA_EXHAUSTED);
            return;
          }

          onAllowed();
        })
        .catch(onAllowed);
    },
    [
      isLockedOut,
      isLoading,
      mutateAsync,
      markSessionQuotaExhausted,
      openUnlockModal,
    ]
  );

  return { guardAnalyze, isCheckingTrialStatus: isLoading };
};
